<div *ngIf="form">
  <div class="page-title" *ngIf="!modoEdicao">
    <h1>Cadastrar aviso</h1>
  </div>

  <div class="page-title" *ngIf="modoEdicao">
    <h1>Editar aviso</h1>
  </div>

  <p class="titulo-secao">INFORMAÇÕES PRINCIPAIS</p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="campo-form">
      <mat-label>Título do aviso</mat-label>
      <input matInput type="text" formControlName="titulo" maxlength="100" />
      <button
        mat-icon-button
        matSuffix
        type="button"
        class="emoji-btn"
        (click)="mostrarEmojiPickerTitulo = !mostrarEmojiPickerTitulo"
      >
        <img alt="inserir emoji" src="../../../../assets/svg/icons/emoji.svg" />
      </button>
      <mat-hint class="legenda-input">Máximo de 100 caracteres</mat-hint>
    </mat-form-field>

    <div
      *ngIf="mostrarEmojiPickerTitulo"
      class="emoji-picker-wrapper emoji-titulo"
    >
      <emoji-mart
        set="apple"
        (emojiClick)="adicionarEmojiTitulo($event)"
        title="Escolha um emoji"
        [style.width.px]="320"
        [darkMode]="false"
      ></emoji-mart>
    </div>

    <mat-form-field
      appearance="outline"
      class="campo-form conteudo-form emoji-inferior"
    >
      <mat-label>Conteúdo do aviso</mat-label>
      <div>
        <textarea
          matInput
          type="text"
          placeholder=""
          formControlName="conteudo"
          maxlength="1000"
        ></textarea>
        <button
          class="emoji-btn"
          mat-icon-button
          matSuffix
          type="button"
          (click)="mostrarEmojiPickerConteudo = !mostrarEmojiPickerConteudo"
        >
          <img
            alt="inserir emoji"
            src="../../../../assets/svg/icons/emoji.svg"
          />
        </button>
        <!-- <button class="link-btn" mat-icon-button matSuffix type="button">
          <img
            alt="adicionar link"
            src="../../../../assets/svg/icons/link.svg"
          />
        </button> -->
      </div>
      <mat-hint class="legenda-input">Máximo de 1000 caracteres</mat-hint>
    </mat-form-field>

    <div
      *ngIf="mostrarEmojiPickerConteudo"
      class="emoji-picker-wrapper emoji-conteudo"
    >
      <emoji-mart
        set="apple"
        (emojiClick)="adicionarEmojiConteudo($event)"
        title="Escolha um emoji"
        [style.width.px]="320"
        [darkMode]="false"
      ></emoji-mart>
    </div>

    <p class="titulo-secao" style="margin-bottom: 12px">
      CONFIGURAR DESTINATÁRIOS
    </p>

    <div
      class="aviso-erro"
      *ngIf="
        form.hasError('nenhumDestinatario') &&
        form.get('camposSelecao')?.touched
      "
    >
      <p>*É necessário selecionar ao menos um destinatário.</p>
    </div>

    <div class="container-seletores">
      <div class="toggle-container primeiro" formGroupName="camposSelecao">
        <mat-slide-toggle formControlName="grupos"></mat-slide-toggle>
        <p>Grupo de empresa</p>
      </div>

      <mat-form-field
        appearance="outline"
        *ngIf="destinatariosVisiveis.grupos"
        class="campo-pesquisa"
      >
        <mat-label>Selecionar grupo de empresas</mat-label>
        <input
          matInput
          type="text"
          readonly
          placeholder=""
          (click)="selecionarGruposDeEmpresas()"
        />
        <button
          class="btn-pesquisa"
          mat-icon-button
          matPrefix
          type="button"
          (click)="selecionarGruposDeEmpresas()"
        >
          <img
            matPrefix
            alt="procurar"
            src="../../../../assets/svg/icons/search.svg"
          />
        </button>
      </mat-form-field>

      <div
        class="container-item-selecionado"
        *ngFor="let grupo of gruposSelecionados"
      >
        <p class="nome-item">{{ grupo.nome }}</p>
        <button class="btn-excluir" (click)="excluirGrupo(grupo.idGrupo)">
          <img alt="excluir" src="../../../../assets/svg/icons/delete.svg" />
        </button>
      </div>

      <div class="toggle-container" formGroupName="camposSelecao">
        <mat-slide-toggle formControlName="empresas"></mat-slide-toggle>
        <p>Empresa</p>
      </div>

      <mat-form-field
        appearance="outline"
        *ngIf="destinatariosVisiveis.empresas"
        class="campo-pesquisa"
      >
        <mat-label>Selecionar empresa</mat-label>
        <input
          matInput
          type="text"
          readonly
          placeholder=""
          (click)="selecionarEmpresas()"
        />
        <button
          class="btn-pesquisa"
          mat-icon-button
          matPrefix
          type="button"
          (click)="selecionarEmpresas()"
        >
          <img
            matPrefix
            alt="procurar"
            src="../../../../assets/svg/icons/search.svg"
          />
        </button>
      </mat-form-field>

      <div
        class="container-item-selecionado"
        *ngFor="let empresa of empresasSelecionadas"
      >
        <p class="nome-item">{{ empresa.nome }}</p>
        <button class="btn-excluir" (click)="excluirEmpresa(empresa.idEmpresa)">
          <img alt="excluir" src="../../../../assets/svg/icons/delete.svg" />
        </button>
      </div>

      <div class="toggle-container" formGroupName="camposSelecao">
        <mat-slide-toggle formControlName="pessoas"></mat-slide-toggle>
        <p>Pessoas</p>
      </div>

      <mat-form-field
        appearance="outline"
        *ngIf="destinatariosVisiveis.pessoas"
        class="campo-pesquisa"
      >
        <mat-label>Selecionar pessoas</mat-label>
        <input
          matInput
          type="text"
          readonly
          placeholder=""
          (click)="selecionarPessoas()"
        />
        <button
          class="btn-pesquisa"
          mat-icon-button
          matPrefix
          type="button"
          (click)="selecionarPessoas()"
        >
          <img
            matPrefix
            alt="procurar"
            src="../../../../assets/svg/icons/search.svg"
          />
        </button>
      </mat-form-field>

      <div
        class="container-item-selecionado"
        *ngFor="let pessoa of pessoasSelecionadas"
      >
        <p class="nome-item">{{ pessoa.nome ?? pessoa.nomeCompleto }}</p>
        <button class="btn-excluir" (click)="excluirPessoa(pessoa.idPessoa)">
          <img alt="excluir" src="../../../../assets/svg/icons/delete.svg" />
        </button>
      </div>

      <div class="toggle-container" formGroupName="camposSelecao">
        <mat-slide-toggle formControlName="usuarios"></mat-slide-toggle>
        <p>Usuários</p>
      </div>

      <mat-form-field
        appearance="outline"
        *ngIf="destinatariosVisiveis.usuarios"
        class="campo-pesquisa"
      >
        <mat-label>Selecionar usuários</mat-label>
        <input
          matInput
          type="text"
          readonly
          placeholder=""
          (click)="selecionarUsuarios()"
        />
        <button
          class="btn-pesquisa"
          mat-icon-button
          matPrefix
          type="button"
          (click)="selecionarUsuarios()"
        >
          <img
            matPrefix
            alt="procurar"
            src="../../../../assets/svg/icons/search.svg"
          />
        </button>
      </mat-form-field>

      <div
        class="container-item-selecionado"
        *ngFor="let usuario of usuariosSelecionados"
      >
        <p class="nome-item">{{ usuario.nome }}</p>
        <button
          class="btn-excluir"
          (click)="excluirUsuario(usuario.id ?? usuario.idUsuario)"
        >
          <img alt="excluir" src="../../../../assets/svg/icons/delete.svg" />
        </button>
      </div>
    </div>

    <p class="titulo-secao">CONFIGURAR DISPARO</p>

    <div class="data-hora-container">
      <mat-form-field appearance="outline" class="campo-form">
        <span matPrefix class="icone-btn">
          <img
            alt="data"
            src="../../../../assets/svg/icons/calendar.svg"
            style="width: 20px; margin-right: 8px"
          />
        </span>
        <input
          readonly
          (focus)="data.open()"
          (click)="data.open()"
          matInput
          [matDatepicker]="data"
          placeholder="Selecionar data*"
          [max]="maxData"
          [min]="minData"
          formControlName="data"
        />
        <mat-datepicker #data></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="campo-form">
        <span matPrefix class="icone-btn">
          <img
            alt="hora"
            src="../../../../assets/svg/icons/clock.svg"
            style="width: 20px; margin-right: 8px"
          />
        </span>
        <input
          readonly
          matInput
          [matTimepicker]="hora"
          placeholder="Selecionar hora*"
          formControlName="hora"
        />
        <mat-timepicker #hora></mat-timepicker>
      </mat-form-field>
    </div>
    <div
      class="aviso-erro"
      *ngIf="
        form.get('hora')?.hasError('horaInvalida') && form.get('hora')?.touched
      "
    >
      <p>
        * A data e o horário selecionados devem ser posteriores ao momento atual.
      </p>
    </div>
  </form>

  <div class="container-inferior">
    <button class="btn-transparente" (click)="sairSemSalvar()">
      Sair sem salvar
    </button>
    <button
      class="btn-contorno"
      [disabled]="!formularioParcialmentePreenchido"
      (click)="salvarEAgendar('RASCUNHO')"
    >
      Salvar como rascunho
    </button>
    <button
      class="btn-cheio"
      [disabled]="!formularioValido"
      (click)="salvarEAgendar('AGENDADO')"
    >
      Salvar e agendar
    </button>
  </div>
</div>
